import {lemon, lemonReady} from "../common/lemon";
import {buildRecommendTop5} from "../common/recommend/recomment_goods";
import Swiper from 'swiper';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

Swiper.use([Navigation, Autoplay, Pagination]);
let design_swiper;
lemonReady(function (){
  let recommendList = lemon("#recommendList");
  buildRecommendTop5({list_container: recommendList});

  //create swiper for sample brand designs
  design_swiper = buildSwiperForMyBrandSamples(".sample-design-swiper");

});

function buildSwiperForMyBrandSamples(target_selector){
  return new Swiper(target_selector, {
    slidesPerView: 2.5,
    spaceBetween: 2,
    grabCursor: true,
    centeredSlides: false,
    autoplay: {
      enabled: true,
      delay: 3000,
      disableOnInteraction: false,
    },
    direction: "horizontal",
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    showSwitchArrows: false,
    loop: true,
    pagination:{
      el: '.swiper-pagination', dynamicBullets: true
    },
    breakpoints: {
      761: {
        slidesPerView: 5,
        spaceBetween: 2,
        showSwitchArrows: true,
        centeredSlides: true,
        loop: true,
        autoplay: {
          enabled: true,
          delay: 3000,
          disableOnInteraction: false,
        },
      }
    }
  });
}